<template>
  <div class="development">
    <Header></Header>
    
    <slideshow></slideshow>
    <div class="showBusiness">
      <div class="showBusiness_left">
        <el-row class="tac">
          <el-col :span="12">
            <el-menu default-active="2" class="el-menu-vertical-demo">
              <el-submenu index="1">
                <template slot="title">
                  <span>业务展示</span>
                </template>
               
                <el-submenu index="1-4">
                  <template slot="title" style="background-color: red"
                    >经营业务</template
                  >
                  <el-menu-item
                    index="1-1-1"
                    class="slash {active:cur==2}"
                    @click="cur = 2"
                    >沿海运输</el-menu-item
                  >
                  <el-menu-item
                    index="1-1-2"
                    class="slash {active:cur==3}"
                    @click="cur = 3"
                    >远洋运输</el-menu-item
                  >
                  <el-menu-item
                    index="1-1-3"
                    class="slash {active:cur==4}"
                    @click="cur = 4"
                    >长江运输</el-menu-item
                  >
                  <el-menu-item
                    index="1-1-4"
                    class="slash {active:cur==5}"
                    @click="cur = 5"
                    >运河运输</el-menu-item
                  >
                  <el-menu-item
                    index="1-1-5"
                    class="slash {active:cur==6}"
                    @click="cur = 6"
                    >船员劳务</el-menu-item
                  >
                  <el-menu-item
                    index="1-1-6"
                    class="slash {active:cur==7}"
                    @click="cur = 7"
                    >船舶管理</el-menu-item
                  >
                  <el-menu-item
                    index="1-1-7"
                    class="slash {active:cur==8}"
                    @click="cur = 8"
                    >天下船员</el-menu-item
                  >
                </el-submenu>
                <el-menu-item
                  index="1-1"
                  class="slash {active:cur==9}"
                  @click="cur = 9"
                  >航运指数</el-menu-item
                >
              </el-submenu>
            </el-menu>
          </el-col>
        </el-row>
      </div>
      <div class="showBusiness_rigth">
        
        <div v-show="cur == 1">
          <div class="business">
            <span class="titlebar">沿海运输</span>
            <div class="crumbs">
              <span>您现在的位置:</span>
              <el-breadcrumb separator-class="el-icon-arrow-right">
                <el-breadcrumb-item :to="{ path: '/' }"
                  >首页</el-breadcrumb-item
                >
                <el-breadcrumb-item>业务展示</el-breadcrumb-item>
                <el-breadcrumb-item>沿海运输</el-breadcrumb-item>
              </el-breadcrumb>
            </div>
          </div>
          <div class="coastwise_size">
            <div>
              中国船舶集团有限公司是按照党中央决策、经国务院批准，于2019年10月14日由
              原中国船舶工业集团有限公司与原中国船舶重工集团有限公司联合重组成立的特大型国有
              重要骨干企业，有科研院所、企业单位和上市公司113家，资产总额8400亿元，员工3
              4.7万人拥有我国最大的造修船基地和最完整的船舶及配套产品研发能力.中国船舶集团有
              限公司是按照党中央决策、经国务院批准，于2019年10月14日由原中国船舶工业集团
              有限公司与原中国船舶重工集团有限公司联合重组成立的特大型国有重要骨干企业，有科
              研院所、企业单位和上市公司113家，资产总额8400亿元，员工34.7万人拥有我国最大
              的造修船基地和最完整的船舶及配套产品研发能力.
            </div>
            <img src="../../assets/img/xiwen03.jpg" alt />
             <div>
              中国船舶集团有限公司是按照党中央决策、经国务院批准，于2019年10月14日由
              原中国船舶工业集团有限公司与原中国船舶重工集团有限公司联合重组成立的特大型国有
              重要骨干企业，有科研院所、企业单位和上市公司113家，资产总额8400亿元，员工3
              4.7万人拥有我国最大的造修船基地和最完整的船舶及配套产品研发能力.中国船舶集团有
              限公司是按照党中央决策、经国务院批准，于2019年10月14日由原中国船舶工业集团
              有限公司与原中国船舶重工集团有限公司联合重组成立的特大型国有重要骨干企业，有科
              研院所、企业单位和上市公司113家，资产总额8400亿元，员工34.7万人拥有我国最大
              的造修船基地和最完整的船舶及配套产品研发能力.
            </div>
            <img src="../../assets/img/xiwen03.jpg" alt />
          </div>
        </div>
       
      </div>
    </div>
    <Footer></Footer>
  </div>
</template>
<script>
import Header from "../../components/haed/haed";
import Footer from "../../components/haed/footer";
import slideshow from "../../components/haed/slideshow";
export default {
  name: "Detailspage",
  components: {
    Header,
    Footer,
    slideshow,
  },
  data() {
    return {
      cur: 1,
    };
  },
  methods:{
    // link_router(){
    //   this.$router.push({ path:'/Detailspage'})
    // }
  }
};
</script>
<style scoped>
.a {
  margin-left: 10px;
}
.business_bottom_box {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
}
.business_bottom_box li {
  width: 19vw;
  height: 18vw;
  margin-top: 10px;
  box-shadow: 0 0 12px 1px #ccc;
  border: 1px solid #ccc;
}
.business_bottom_box li img {
  width: 100%;
  height: 63%;
}
.business_bottom_box li div {
  text-align: center;
  font-size: 1.2vw;
  color: #0843a1;
}
.business_bottom_box li span {
  color: #0843a1;
  line-height: 2;
  width: 96%;
  margin: 0 auto;
  display: block;
  font-size: 1vw;
}

.showBusiness {
  /* height: 1400px; */
  /* width: 99%; */
  display: flex;
  margin-top: 1%;
}

.management {
  position: relative;
}
.management .management_sisz {
  position: absolute;
  top: 43%;
  left: 5%;
  color: #fff;
  font-size: 2.2vw;
  margin-left: 18%;
}
.coastwise_size div {
  font-size: 16px;
  line-height: 2;
  font-weight: bold;
  margin: 3% 0;
}
.coastwise_size img {
  width: 100%;
}
.showBusiness_left {
  width: 28%;
}

.showBusiness_rigth {
  width: 77%;
  /* height: 70vw; */
  margin-left: -9%;
  margin-bottom: 2%;
}
.business {
  display: flex;
  justify-content: space-between;
  border-bottom: 1px solid #dcdcdc;
  margin: 15px 0;
}
.titlebar {
  font-weight: bold;
  font-size: 20px;
  color: #31518c;
}
.Figure {
  margin-top: 20px;
  margin-bottom: 20px;
}
.slash {
  text-align: center;
  /* padding-left: 44px !important; */
  border: 1px solid #eee;
  margin: 0 0 -1px -1px;
  height: 1.9vw;
  line-height: 1.9vw;
}

.el-menu {
  border-right: none;
}
.crumbs {
  display: flex;
}
.crumbs span {
  color: #969696;
}

.el-row {
  padding-left: 5%;
}
.el-submenu .el-menu-item {
  min-width: 1px;
}
.el-breadcrumb {
  line-height: 1.5;
}
</style>
<style>
.development .el-submenu__title {
  text-align: center;
  background-color: #0c47a1;
  color: #fff;
}
.development .el-submenu .el-menu .el-submenu__title {
  background-color: #fff;
  color: #000;
  border-right: 1px solid #eee;
  border-left: 1px solid #eee;
  line-height: 1.9vw;
  height: 1.9vw;
  padding-left: 17px !important;
}
.el-menu-item:focus,
.el-menu-item:hover {
  background: #fff;
}
</style>


// WEBPACK FOOTER //
// src/pages/development/Detailspage.vue